import React from "react";
import { Link } from "react-router-dom";

function Navigation() {
  return (
    <>
      <nav className="navbar navbar-expand-md navbar-dark bg-dark sticky-top py-1">
        <div className="container-fluid">
          <span className="navbar-brand mb-0 h1 water-brush fs-1">
            <Link to="/" className="text-decoration-none">
              Lasyanga
            </Link>
          </span>

          <button
            className="navbar-toggler border-0"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbar"
            aria-controls="navbar"
            aria-expanded="false"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse raleway fw-bolder" id="navbar">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link to="/about-me" className="nav-link">
                  About Me
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/my-works" className="nav-link">
                  My Works
                </Link>
              </li>
              {/* <li className="nav-item">
                <Link to="/contact" className="nav-link">
                  Contact Me
                </Link>
              </li> */}
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navigation;
